export default "__VITE_ASSET__oAuZQYQh__"